import { render } from "./forgot-password.vue?vue&type=template&id=896679a0&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"

import "./forgot-password.vue?vue&type=style&index=0&id=896679a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896679a0"]])

export default __exports__